import { useLocale } from "../../hooks/useLocale";
import { msg } from "../../locales/translate";
import { Box, HBox, VBox } from "@ui/box/Box";
import Button from "@ui/button/Button";
import { Error } from "@ui/error/Error";
import Panel from "@ui/panel/Panel";
import Spacer from "@ui/spacer/Spacer";
import { Rows } from "@ui/table/Rows";
import { Typo } from "@ui/text/Typo";
import Signal from "badmfck-signal";
import { useEffect, useState } from "react";
import { GD } from "src/GD";
import { IAcquirerChannel, ITerminal } from "src/types/types";
import { TerminalBadge } from "../conponents/TerminalBadge";
import { S_CONFIRM } from "./general/ConfirmDialog";
import { IconCheck } from "@ui/icons/IconCheck";

export const S_ADD_CHANNEL_POPUP = new Signal<{
	merchantID: number;
	onSuccess: () => void;
} | null>("S_ADD_CHANNEL_POPUP");

declare type ChannelSelect = IAcquirerChannel & { selected: boolean; terminal?: ITerminal };

//!TODO: unused?
export const AddChannelPopup = () => {
	useLocale();
	const requestData = S_ADD_CHANNEL_POPUP.use();
	const [busy, setBusy] = useState<boolean>();
	const [error, setError] = useState<IError>();
	const [acquirers, setAcquirers] = useState<{ acquirer: IAcquirer; channels: IAcquirerChannel[] }[]>();
	const [selectedAcquirer, setSelectedAcquirer] = useState<{ acquirer: IAcquirer; channels: IAcquirerChannel[] }>();

	const [items, setItems] = useState<ChannelSelect[]>();
	const [selected, setSelected] = useState<number>(0);

	//!TODO: remove ts;
	const [terminals] = GD.B_TERMINALS.use({ ts: +new Date() });

	useEffect(() => {
		if (requestData && terminals?.data) {
			loadAcquirers();
		}
	}, [requestData, terminals]);

	useEffect(() => {
		if (selectedAcquirer && terminals?.data) {
			const data: ChannelSelect[] =
				selectedAcquirer.channels?.map(a => {
					return { terminal: terminals.data?.find(t => t.id === a.terminal_id), selected: false, ...a };
				}) ?? [];
			setItems(data);
		} else {
			setItems(undefined);
		}
	}, [selectedAcquirer, terminals]);

	const loadAcquirers = async () => {
		setBusy(true);
		if (requestData && terminals && terminals.data) {
			const existChannels = await GD.REQ_MERCHANT_ATTACHED_CHANNELS.request({
				merchantID: requestData.merchantID,
			});

			const attachedTerminals = await GD.B_MERCHANT_ATTACHED_TERMINALS.execute({ merchantID: requestData.merchantID });

			//existChannels && (existChannels.error = undefined);
			//existChannels && (existChannels.data = []);

			if (existChannels?.error || attachedTerminals?.error) {
				setError(existChannels?.error || attachedTerminals?.error);
			} else {
				const res = await GD.REQ_MERCHANT_AQUIRERS.request({
					merchantID: requestData.merchantID,
				});

				if (res?.error) {
					setError(res?.error);
				} else if (res?.data) {
					const acquirersToShow: { acquirer: IAcquirer; channels: (IAcquirerChannel & { selected: boolean })[] }[] = [];
					for (const acquirer of res?.data ?? []) {
						const resChannels = await GD.REQ_CHANNELS.request({
							acquirerId: acquirer.id,
							showDeleted: false,
						});
						if (resChannels) {
							if (!resChannels.error) {
								let chennelsToAdd = resChannels.data;
								// remove chennels without terminal;
								chennelsToAdd = chennelsToAdd.filter(
									c => c.terminal_id !== undefined && c.terminal_id !== null && terminals?.data?.find(t => t.id === c.terminal_id)
								);

								if (chennelsToAdd.length > 0) {
									// remove existing channels;
									if (existChannels && existChannels.data.length > 0) {
										chennelsToAdd = chennelsToAdd.filter(c => !existChannels.data.find(existind => existind.id === c.id));
									}
									//2 remove non existing terminals;
									if (chennelsToAdd.length > 0) {
										chennelsToAdd = chennelsToAdd.filter(c => attachedTerminals?.data.find(t => t.id === c.terminal_id));
									}
								}

								if (chennelsToAdd.length > 0) {
									acquirersToShow.push({
										acquirer: acquirer,
										channels: chennelsToAdd.map(c => {
											return { ...c, selected: false };
										}),
									});
								}
							} else {
								//!TODO:;
							}
						}
					}

					if (acquirersToShow.length > 0) {
						setAcquirers(acquirersToShow);
					} else {
						S_CONFIRM.invoke({
							message: msg("noChannelsFoundThatCouldBeAdded"),
							confirm: "Back",
							onResult: () => {},
						});
						closePopup();
					}
				}
			}
		}
		setBusy(false);
	};

	if (!requestData) return null;

	const closePopup = () => {
		S_ADD_CHANNEL_POPUP.invoke(null);
		setError(undefined);
		setAcquirers(undefined);
		setItems(undefined);
		setSelectedAcquirer(undefined);
		setSelected(0);
	};

	const showChannels = async (acquirer: IAcquirer) => {
		const find = acquirers?.find(a => a.acquirer.id === acquirer.id);
		if (find) {
			setSelectedAcquirer(find);
		}
	};

	const addChannels = async () => {
		if (items) {
			const selectedItems = items.filter(i => i.selected);
			let error = false;
			if (selectedItems.length > 0) {
				setBusy(true);
				for (const channel of selectedItems) {
					const res = await GD.REQ_MERCHANT_ADD_CHANNEL.request({
						merchantID: requestData.merchantID,
						channelID: channel.id,
					});
					if (res?.error) {
						error = true;
						setError(res?.error);
						break;
					}
				}
				setBusy(false);
				if (!error) {
					requestData.onSuccess && requestData.onSuccess();
					closePopup();
				}
			}
		}
	};

	const updateSelection = (val: any) => {
		const newValue = !val.selected;

		// if (items && !request.multi) {
		// 	items.forEach(i => (i.selected = false));
		// }
		val.selected = newValue;
		setItems(items ? [...items] : undefined);
		setSelected(items?.filter(i => i.selected).length ?? 0);
	};

	let content = <Spacer size="70px" />;
	if (selectedAcquirer) {
		content = (
			<VBox gap="12px" sx={{ height: "100%" }}>
				<HBox gap="20px" sx={{ alignItems: "center" }}>
					<Button
						variant="secondarySmall"
						title={msg("back_881f146b")}
						onClick={() => {
							setItems(undefined);
							setSelected(0);
							setSelectedAcquirer(undefined);
						}}
					/>
				</HBox>

				{items && (
					<VBox gap="12px" sx={{ height: "100%" }}>
						<Typo variant="text" sx={{ display: "inline" }}>
							{msg("payMethod") + selectedAcquirer.acquirer.name + msg("channels_a94686a8")}
						</Typo>

						<Rows<ChannelSelect>
							gridTemplateColumns="max-content max-content auto max-content max-content"
							itemType="Channel"
							searchable={items.length > 10}
							controlsPadding="20px"
							order={["terminal", "title", "status", "selected"]}
							data={items}
							onClick={(row, _cell) => {
								updateSelection(row);
							}}
							cellFactory={(row, _cell, _idx, _key, name, sx) => {
								if (name === "title") {
									return {
										content: (
											<VBox>
												<Typo variant="text">{row.title}</Typo>
												<Typo variant="small">{row.alias}</Typo>
											</VBox>
										),
									};
								}
								if (name === "terminal") {
									if (row.terminal) {
										sx && (sx.padding = "0px");
										sx && (sx.paddingLeft = "10px");
										return {
											content: <TerminalBadge terminal={row.terminal} />,
											sx,
										};
									} else {
										return {
											content: <div />,
										};
									}
								}

								if (name === "selected") {
									if (sx) {
										sx.padding = "0px";
										sx.paddingRight = "12px";
									}
									return {
										content: <Box sx={{ width: "20px", height: "20px", alignSelf: "center" }}>{row.selected && <IconCheck />}</Box>,
										sx: sx,
									};
								}

								return { content: null };
							}}
						/>
					</VBox>
				)}
			</VBox>
		);
	} else if (acquirers) {
		content = (
			<VBox gap="12px">
				<Typo variant="text" sx={{ display: "inline" }}>
					{msg("selectAcquirer")}
				</Typo>

				<Rows
					data={acquirers.map(a => a.acquirer)}
					itemType="acquirer"
					order={["__itemType", "name", "status"]}
					gridTemplateColumns="max-content auto max-content"
					onClick={row => {
						showChannels(row);
					}}
					cellFactory={(_row, cell, _index, _key, name, _sx) => {
						if (
							cell === "__actions" ||
							name === "__itemType" ||
							name === "__itemOrderDivider" ||
							name === "created_at" ||
							name === "updated_at" ||
							name === "status"
						) {
							return {
								content: "",
							};
						}
						return {
							content: "",
						};
					}}
				/>
			</VBox>
		);
	}

	return (
		<Panel
			sx={{
				maxWidth: "1200px",
				maxHeight: "86vh",
				// padding: "0px",
				minWidth: "600px",
				backgroundColor: "#EEF0F2",
			}}
			decorator="absolute"
			busy={busy}
			label={msg("addChannel_ad6357a1")}
			onClose={closePopup}>
			<VBox
				gap="20px"
				sx={{
					overflow: "auto",
					flexGrow: 1,
					padding: "0px 0px",
					backgroundColor: "#EEF0F2",
				}}>
				{content}
			</VBox>

			<Spacer size="20px" />

			<VBox sx={{ gap: "12px" }}>
				<Error error={error} />
				<Button
					title={selectedAcquirer ? (selected > 0 ? msg("addChannels") : msg("close")) : msg("back")}
					onClick={() => {
						selectedAcquirer && selected > 0 ? addChannels() : closePopup();
					}}
				/>
			</VBox>
		</Panel>
	);
};
